/**
 * Bundle entry for the browser build of the learning-surface client.
 *
 * `FacilitatorApi` is the one surface left out — it needs an oauth2-proxy
 * cookie a static game page or the take-home redeem page never holds.
 * `PublicApi`/`LearnerApi` are for the game pages and the Angular sandbox
 * wrapper (session join, Visit/Attempt/Artifact lifecycle); `TakeHomeApi` is
 * for the Angular take-home redeem page (`/me/:token`) —
 * `getTakeHome`/`getTakeHomeArtifact` exist only on this surface, not as some
 * overlap with `LearnerApi`. Bundling it here too, rather than standing up a
 * second bundle, keeps one `window.LearnApi` for every caller.
 *
 * esbuild turns this into `public/learn-api/v1/learn-api.js`, an IIFE exposing
 * everything below on `window.LearnApi`.
 */
export { LearnerApi, PublicApi, TakeHomeApi } from './v1/apis';
export {
  Configuration,
  ResponseError,
  FetchError,
  RequiredError,
} from './v1/runtime';
